import Storage from '../../../lib/Storage'
import StackAPI from '../../../lib/StackAPI'
import { OrgUser } from '../types/OrgUser'

const ENDPOINT = '/partners/users'

export const inviteOrgUser = async (values: OrgUser) => {
  const { post } = StackAPI()
  const { organizationId: orgId } = Storage().getActiveRole()

  const headers = {
    Accept: 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json'
  }

  const params = {
    user: {
      email: values.email,
      first_name: values.firstName,
      last_name: values.lastName,
      organization_id: orgId,
      send_invitation: true,
      source_app: 'partners_client'
    }
  }

  const request = {
    path: ENDPOINT,
    params,
    headers
  }

  return await post(request)
    .then(({ status }) => (status === 201 ? 'Invitation sent!' : []))
    .catch(() => ({ error: 'unknown error' }))
}
